import classNames from 'classnames';
import { ErrorMessage, Field } from 'formik';
import React, { memo } from 'react';
import FormField from '../FormField/FormField';
import { FormFieldBlokProps } from '../FormFieldBlokProps.interface';
import { FormFieldSelectOptionBlokProps } from '../FormFieldSelectOptionBlokProps.interface';

export interface FormFieldMultiOptionsSelectBlokProps
  extends FormFieldBlokProps {
  options: FormFieldSelectOptionBlokProps[];
  preselected_options: FormFieldSelectOptionBlokProps[];
}

interface FormFieldMultiOptionsSelectProp {
  blok: FormFieldMultiOptionsSelectBlokProps;
}

const isOptionSelected = (
  option: FormFieldSelectOptionBlokProps,
  selectedOptions: FormFieldSelectOptionBlokProps[]
): boolean => {
  return selectedOptions.indexOf(option) > -1;
};

const FormFieldMultiOptionsSelect: React.FC<
  FormFieldMultiOptionsSelectProp
> = ({ blok }) => {
  const {
    label,
    description = undefined,
    is_required,
    error_message = undefined,
    tool_tip = [],
    key,
    options,

    preselected_options,
  } = blok;

  return (
    <FormField
      label={label}
      description={description}
      errorMessage={error_message}
      toolTip={tool_tip}
      key={key}
    >
      <ul className="pt-6 space-y-6">
        {options.map((option: FormFieldSelectOptionBlokProps) => (
          <li
            key={option._uid}
            className="flex items-center justify-start gap-x-3"
          >
            <Field
              type="checkbox"
              id={option.value}
              name={key}
              value={option.value}
              className={classNames(
                'w-[18px] h-[18px] border-2 rounded-xs text-button/primary-bg checked:border-button/primary-bg'
              )}
            />
            <label
              htmlFor={option.value}
              className="font-dm-sans text-text/body"
            >
              {option.description}
            </label>
          </li>
        ))}
      </ul>
      <ErrorMessage
        name={key}
        render={(msg) => (
          <div className="text-text/body-primary pt-4">{msg}</div>
        )}
      />
    </FormField>
  );
};

export default memo(FormFieldMultiOptionsSelect);
